<template>
  <div class="layout">
		<div class="layout__header">
			<div class="layout__title">
				<h3>Ciudad</h3>
			</div>
		</div>
		<div class="layout__main">
			<div class="layout__main-form">
				<div class="card">
					<div class="card__content">
						<div class="row">
							<div class="col-xs-12 col-md-6">
								<input-field v-model="form.descripcion" id="descripcion" placeholder="Nombre de la ciudad...">
									Nombre
									<span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
										<strong>{{ errores.descripcion[0] }}</strong>
									</span>
								</input-field>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="layout__main-buttons">
				<div class="card">
					<div class="card__content">
						<button @click="botonGuardar" class="btn-success"><i class="fa fa-save"></i><span>Guardar</span></button>
						<button @click="botonLimpiar" class="btn-primary btn--text"><i class="fa fa-refresh"></i><span>Limpiar</span></button>
						<button @click="botonCerrar" class="btn-danger"><i class="fa fa-times-circle"></i><span>Cerrar</span></button>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>
<script>
export default {
	props: {
		propCiudad: {
			type: Object,
			required: false,
			default: function(){
				return null;
			}
		},
		paisId: {
			type: String,
			required: true,
		},
		provinciaId: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			paises: [],
			provincias: [],
			ciudad: this.propCiudad,
			form: {
				pais_id: this.paisId,
				provincia_id: this.provinciaId,
				ciudad_id: '',
				descripcion: '',
			},
			errores: {}
		}
	},
	mounted() {
		if(this.ciudad != null){
			this.form.provincia_id = this.ciudad.id_provincia;
			this.form.ciudad_id = this.ciudad.id_ciudad;
			this.form.descripcion = this.ciudad.descripcion;
			this.form.pais_id = this.ciudad.provincia.id_pais;
		}
	},
	methods: {
		limpiarErrores: function(){
			this.errores = {};
		},
		limpiar: function(){
			this.form.provincia_id = this.provinciaId;
			this.form.pais_id = this.paisId;
			this.form.ciudad_id = '';
			this.form.descripcion = '';
			this.ciudad = null;
			this.limpiarErrores();
		},
		botonLimpiar: function(){
			swal.fire({
				title: '¿Desea limpiar los campos?',
				text: "Esta acción requiere de confirmación.",
				type: 'question',
				showCancelButton: true,
				confirmButtonText:'Aceptar'
				}).then((result) => {
					if (result.value) {
						this.limpiar();
					}
				});
		},
		botonGuardar: function(){
			swal.fire({
				title: '¿Deseas guardar la Ciudad?',
				text: "Esta acción requiere de confirmación.",
				type: 'question',
				showCancelButton: true,
				confirmButtonText:'Aceptar'
		}).then((result) => {
				if (result.value) {
					let urlApi = '';
					if(this.ciudad != null)
						urlApi = url+ '/zona-geografica/editar-ciudad';
					else
						urlApi = url+ '/zona-geografica/guardar-ciudad';
					axios.post(urlApi, this.form).then(response => {
						let data = response.data;
						this.limpiarErrores();
						swal.fire('Almacenado', 'Se ha almacenado satisfactoriamente.', 'success');
						this.$emit('cargarCiudad', data.ciudad, data.pais);
						this.$modal.hide('ciudad');
					}).catch(error => {
						if (error !== undefined && error !== null) {
							let response = error.response;
							if (response !== undefined && response !== null) {
								let status = response.status;
								if (status === 422) {
									this.errores = response.data.errors;
									swal.fire("Hay validaciones por corregir.", "Aviso", "warning");
								} else{
										if(response.data.message != null && response.data.message != '')
											swal.fire('Error', response.data.message, 'error');
										else
											swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
									}
							}
						}
					});
				}
			});
		},
		botonCerrar: function(){
			this.$modal.hide('ciudad');
		},
	},
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/zona-geografica/Ciudad.vue